import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLocation } from 'ducks/router'
import { useModal } from 'hooks'
import { candidates } from 'orm'

const useDeleteCandidateModalQueries = () => {
  const dispatch = useDispatch()

  const handleFetchCandidates = React.useCallback(
    (
      { projectId, status },
      { limit, offset, ordering, search, is_favourite, hire_status },
    ) => {
      dispatch(
        candidates.fetchStart({
          project: projectId,
          limit,
          offset,
          ordering,
          search,
          status,
          is_favourite,
          hire_status,
        }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchCandidates,
  }
}

const useDeleteCandidateModalMutations = () => {
  const dispatch = useDispatch()

  const handleDeleteCandidate = React.useCallback(
    ({ id }, { postSuccessAction } = {}) => {
      dispatch(candidates.deleteStart({ pk: id, postSuccessAction }))
    },
    [dispatch],
  )

  return {
    handleDeleteCandidate,
  }
}

export const useDeleteCandidateModal = (state, handlers = {}) => {
  const { id, projectId, status } = state
  const { handleReset } = handlers

  const { query = {} } = useSelector(getLocation)

  const { handleClose, handleOpen, isOpen } = useModal()

  const { handleFetchCandidates } = useDeleteCandidateModalQueries()

  const { handleDeleteCandidate } = useDeleteCandidateModalMutations()

  const handlePostSuccessAction = React.useCallback(() => {
    handleClose()
    handleReset()
    handleFetchCandidates({ projectId, status }, query)
  }, [
    projectId,
    query,
    status,
    handleClose,
    handleReset,
    handleFetchCandidates,
  ])

  const handleDeleteCandidateModalClose = React.useCallback(() => {
    handleClose()
    handleReset()
  }, [handleClose, handleReset])

  const handleDeleteCandidateModalConfirm = React.useCallback(() => {
    handleDeleteCandidate(
      { id },
      { postSuccessAction: handlePostSuccessAction },
    )
  }, [id, handleDeleteCandidate, handlePostSuccessAction])

  return {
    handleDeleteCandidateModalClose,
    handleDeleteCandidateModalConfirm,
    handleDeleteCandidateModalOpen: handleOpen,
    isDeleteCandidateModalOpen: isOpen,
  }
}
